import { PiMoonBold, PiSunFill } from 'react-icons/pi'
import { Switch } from '@material-tailwind/react'
import { useDarkMode } from '../contexts/DarkModeContext'

export const ThemeSelector = () => {
  const { darkMode, toggleDarkMode } = useDarkMode()

  const textColorClass = darkMode ? 'text-white' : 'text-white-yellow'

  return (
    <div className={`flex items-center space-x-2 ${textColorClass}`}>
      <PiSunFill className="text-xl" />
      <Switch
        id="dark-mode-toggle"
        checked={darkMode}
        onChange={toggleDarkMode}
        ripple={false}
        className={`w-9 ${darkMode ? 'bg-gray-500' : 'bg-gray-500'}`}
        circleProps={{
          className: `${darkMode ? 'bg-white' : 'bg-white-yellow'} before:hidden`,
        }}
      />
      <PiMoonBold className="text-xl" />
    </div>
  )
}
